import { Button, Checkbox, Dialog, DialogActions, DialogContent } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import DialogHeader from './DialogHeader'
import { useTranslation } from 'react-i18next'
import { DIEU_10, DIEU_11, DIEU_12, DIEU_1_DINH_NGHIA, DIEU_2_LOAI_DU_LIEU_XU_LY, DIEU_3_MUC_DICH_XU_LY_DU_LIEU_CA_NHAN, DIEU_4_KHACH_HANG_DUOI_16_TUOI, DIEU_5_CACH_THUC_XU_LY_DU_LIEU, DIEU_6, DIEU_7, DIEU_8, DIEU_9, LANH_THO, TABLE_PL01 } from './data'
import './dialog.css'
import AcceptPolicy from 'assets/img/accept-policy.png'
import { useHandlerUser } from 'hooks/useHandlerUser'

const DialogAcceptPolicy = ({
    titleKey,
    onClose,
    onAction,
    onReject
}) => {
    const { t } = useTranslation()
    const ref = useRef(null);
    const [scrollEnd, setScrollEnd] = useState(false)
    const [element, setElement] = useState(null);
    const { handleLogout } = useHandlerUser()
    const [isValidPolicy1, setIsValidPolicy1] = useState([true, true, true, false, false, false])
    // const [isValidPolicy2, setIsValidPolicy2] = useState([true, true, true, false, false, false])
    const isValid = scrollEnd && isValidPolicy1.slice(0, 3).every(Boolean)

    const handleReject = async () => {
        if(onReject) {
            onReject()
        } else {
            handleLogout()
        }
        onClose()        
    }
    
    const handleAction = () => { 
        onAction && onAction(isValidPolicy1.map(v => v ? 1 : 0))
        onClose()
    }

    const handleChangePolicy1 = (event, index) => {
        const { checked } = event.target
        setIsValidPolicy1(prev => {
            const clone = [...prev];
            clone[index] = checked;   // cập nhật đúng checkbox đang thay đổi
            return clone;
        });
    }

    // const handleChangePolicy2 = (event, index) => {
    //     const { checked } = event.target
    //     setIsValidPolicy2(prev => {
    //         const clone = [...prev];
    //         clone[index] = checked;   // cập nhật đúng checkbox đang thay đổi
    //         return clone;
    //     });
    // }
    
    useEffect(() => {
        const timer = setInterval(() => {
            const el = document.getElementById("accept-policy");

            if (el) {
                setElement(true)
                clearInterval(timer)
            }
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (!element) return;

        const target = document.getElementById("accept-policy");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setScrollEnd(true)
                    }
                });
            },
            {
                root: null,
                threshold: 0.1,
            }
        );

        if (target) observer.observe(target);

        return () => {
            if (target) observer.unobserve(target);
        };
    }, [element]);

    return (
        <Dialog open fullWidth maxWidth="md">
            <DialogHeader titleKey={titleKey} />
            <DialogContent>
                <div style={{ textAlign: 'center', marginTop: 20 }}><img alt='accept-policy' src={AcceptPolicy} width={200} /></div>
                <p>Khách hàng đồng ý với Văn bản chấp thuận về xử lý và bảo vệ dữ liệu cá nhân (“Văn Bản”)
                    do Viettel xây dựng để quy định việc xử lý Dữ liệu cá nhân, quy tắc bảo vệ Dữ liệu cá nhân của
                    Khách hàng và trách nhiệm bảo vệ Dữ liệu cá nhân của Viettel với nội dung như sau:</p>
                <h3>ĐIỀU 1. ĐỊNH NGHĨA</h3>
                <ol>
                    {DIEU_1_DINH_NGHIA.map((item, index) => (
                        <li key={index}>
                            <strong>{item.parentKey}</strong> {item.parentContent}
                            {item?.childen && item.childen.map(((content, index) => <p key={index}>{content}</p>))}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 2. LOẠI DỮ LIỆU XỬ LÝ</h3>
                <ol>
                    {DIEU_2_LOAI_DU_LIEU_XU_LY.map((item, index) => (
                        <li key={index}>
                            {item.parent}
                            {item?.childen && item.childen.map(((content, index) => <p key={index}>{content}</p>))}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 3. MỤC ĐÍCH XỬ LÝ DỮ LIỆU CÁ NHÂN</h3>
                <p>Dữ liệu cá nhân theo Điều 2 trên đây có thể được xử lý cho các mục đích sau:</p>
                <ol>
                    {DIEU_3_MUC_DICH_XU_LY_DU_LIEU_CA_NHAN.map((item, index) => (
                        <li key={index}>
                            {item.parent}
                            {item?.childen && item.childen.map(((content, index) => <p key={index}>{content}</p>))}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 4: XỬ LÝ DỮ LIỆU CỦA KHÁCH HÀNG DƯỚI 16 TUỔI</h3>
                <ol>
                    {DIEU_4_KHACH_HANG_DUOI_16_TUOI.map((item, index) => (
                        <li key={index}>
                            {item.parent}
                            {item?.childen && item.childen.map(((content, index) => <p key={index}>{content}</p>))}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 5: CÁCH THỨC XỬ LÝ DỮ LIỆU</h3>
                <ol>
                    {DIEU_5_CACH_THUC_XU_LY_DU_LIEU.map((item, index) => (
                        <li key={index}>
                            <strong>{item.parentKey}</strong>
                            <p dangerouslySetInnerHTML={{ __html: item.parentContent }}></p>
                            {item?.childen && item.childen.map(((content, indexC) => <p key={indexC}>
                                {content}
                                {index === 2 && indexC === 1 && LANH_THO.map((lt, id) => <p key={id}>{lt}</p>)}
                            </p>))}
                            {index === 0 && <p>Chúng tôi cũng có thể thu thập Dữ liệu cá nhân gián tiếp từ Quý khách thông qua các nguồn thông tin công khai, chính thống; hoặc thông qua việc nhận chia sẻ dữ liệu cần thiết từ các công ty con, đối tác mà họ thu thập được trong quá trình hợp tác với Viettel cung cấp Sản phẩm, hàng hóa, dịch vụ cho Quý khách và được Quý khách cho phép chia sẻ.</p>}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 6: NGUYÊN TẮC BẢO MẬT DỮ LIỆU CỦA VIETTEL</h3>
                <ol>
                    {DIEU_6.map((item, index) => (
                        <li key={index}>
                            {item.parent}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 7: HẬU QUẢ, THIỆT HẠI KHÔNG MONG MUỐN CÓ KHẢ NĂNG XẢY RA</h3>
                <ol>
                    {DIEU_7.map((item, index) => (
                        <li key={index}>
                            {item.parent}
                            {item?.childen && item.childen.map(((content, index) => <p key={index}>{content}</p>))}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 8: THỜI GIAN BẮT ĐẦU, THỜI GIAN KẾT THÚC XỬ LÝ DỮ LIỆU CÁ NHÂN</h3>
                <ol>
                    {DIEU_8.map((item, index) => (
                        <li key={index}>
                            {item.parent}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 9: TỔ CHỨC, CÁ NHÂN THAM GIA QUÁ TRÌNH XỬ LÝ DỮ LIỆU CÁ NHÂN</h3>
                <ol>
                    {DIEU_9.map((item, index) => (
                        <li key={index}>
                            {item.parent}
                            {item?.childen && item.childen.map(((content, index) => <p key={index}>{content}</p>))}
                            {index === 1 && <p>Việc chia sẻ dữ liệu sẽ được thực hiện theo đúng trình tự, cách thức và quy định pháp luật hiện hành. Các bên tiếp nhận Dữ liệu cá nhân có nghĩa vụ bảo mật Dữ liệu cá nhân của Quý khách phù hợp với Văn Bản này; các quy định, quy trình, tiêu chuẩn về Bảo vệ Dữ liệu cá nhân của Viettel và quy định pháp luật hiện hành.</p>}
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 10: QUYỀN CỦA KHÁCH HÀNG</h3>
                <ol>
                    {DIEU_10.map((item, index) => (
                        <li key={index}>
                            <p dangerouslySetInnerHTML={{ __html: item.parent }}></p>
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 11: NGHĨA VỤ CỦA KHÁCH HÀNG</h3>
                <ol>
                    {DIEU_11.map((item, index) => (
                        <li key={index}>
                            <p>{item.parent}</p>
                        </li>
                    ))}
                </ol>
                <h3>ĐIỀU 12: ĐIỀU KHOẢN CHUNG</h3>
                <ol>
                    {DIEU_12.map((item, index) => (
                        <li key={index}>
                            <p>{item.parent}</p>
                        </li>
                    ))}
                </ol>
                <h3 style={{ textAlign: 'center' }}>
                    PHỤ LỤC 01 <br />
                    XÁC NHẬN SỰ ĐỒNG Ý ĐỐI VỚI MỤC ĐÍCH XỬ LÝ DỮ LIỆU CÁ NHÂN
                </h3>
                <p>Bằng việc đánh dấu vào các ô đồng ý trong bảng dưới đây, Khách hàng xác nhận đồng ý cho Viettel Xử lý dữ liệu cá nhân cho các mục đích như sau:</p>
                <table className='policy'>
                    <tr>
                        <th>STT</th>
                        <th>Mục đích xử lý</th>
                        <th>Đồng ý</th>
                    </tr>
                    {TABLE_PL01.map((item) => <tr key={item.index}>
                        <td>{item.index}{item?.isRequired && <span style={{ color: '#EE0033' }}>*</span>}</td>
                        <td><p dangerouslySetInnerHTML={{ __html: item.content }}></p></td>
                        <td><Checkbox checked={isValidPolicy1[item.index-1]} onChange={(e) => handleChangePolicy1(e, item.index - 1)}/></td>
                    </tr>)}
                </table>
                <strong style={{ marginTop: 12, display: 'block' }}>Lưu ý của Viettel:</strong>
                <p>Quý khách có quyền lựa chọn một, một số hoặc toàn bộ các mục đích xử lý dữ liệu cá nhân của mình đã liệt kê phía trên. Tuy nhiên, do tính chất của Sản phẩm, hàng hóa, dịch vụ, chúng tôi đặc biệt lưu ý rằng việc Quý khách đồng ý với các mục đích theo khoản 1, 2, 3 Điều 3 Văn Bản này là điều kiện bắt buộc để Viettel có thể cung cấp Sản phẩm, hàng hóa, dịch vụ theo Hợp đồng, đảm bảo chất lượng và trải nghiệm sử dụng dịch vụ của Quý khách. </p>
                <p>Đối với các mục đích theo khoản 4, 5, 6 Điều 3 Văn Bản này, chúng tôi chỉ thực hiện xử lý dữ liệu khi có sự đồng ý bằng tích chọn của Quý khách. Trường hợp Quý khách đã đồng ý cho chúng tôi Xử lý dữ liệu mà thay đổi ý định và/hoặc muốn từ chối nhận thông tin tiếp thị, giới thiệu sản phẩm, quảng cáo và khuyến mại, Quý khách có thể cho chúng tôi biết bất kỳ lúc nào bằng việc gửi yêu cầu cho chúng tôi theo các phương thức theo quy định tại khoản 13 Điều 10 Văn Bản này. </p>
                <p>Ngoại trừ các mục đích xử lý dữ liệu nêu trên, nếu cần xử lý dữ liệu cá nhân của Quý khách cho bất kỳ mục đích nào khác, chúng tôi sẽ thông báo cho Quý khách và chỉ tiến hành xử lý dữ liệu cá nhân phù hợp với sự đồng ý của Quý khách.</p>
                {/* <h3 style={{ textAlign: 'center' }}>
                    PHỤ LỤC 02 <br />
                    XÁC NHẬN SỰ ĐỒNG Ý CỦA CHA, MẸ HOẶC NGƯỜI GIÁM HỘ ĐỐI VỚI
                    MỤC ĐÍCH XỬ LÝ DỮ LIỆU CÁ NHÂN CỦA KHÁCH HÀNG TRẺ EM
                </h3>
                <p>Bằng việc đánh dấu vào các ô đồng ý trong bảng dưới đây, Tôi là cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em, xác nhận đồng ý cho Viettel Xử lý dữ liệu cá nhân cho các mục đích như sau:</p>
                <table className='policy'>
                    <tr>
                        <th>STT</th>
                        <th>Mục đích xử lý</th>
                        <th>Đồng ý</th>
                    </tr>
                    {TABLE_PL02.map((item) => <tr key={item.index}>
                        <td>{item.index}{item?.isRequired && <span style={{ color: '#EE0033' }}>*</span>}</td>
                        <td>
                            <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
                        </td>
                        <td><Checkbox checked={isValidPolicy2[item.index-1]} onChange={(e) => handleChangePolicy2(e, item.index - 1)} /></td>
                    </tr>)}
                </table>
                <strong style={{ marginTop: 12, display: 'block' }}>Lưu ý của Viettel:</strong>
                <p>Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em có quyền lựa chọn một, một số hoặc toàn bộ các mục đích xử lý dữ liệu cá nhân của mình đã liệt kê phía trên. Tuy nhiên, do tính chất của Sản phẩm, hàng hóa, dịch vụ, chúng tôi đặc biệt lưu ý rằng việc Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em đồng ý với các mục đích theo khoản 1, 2, 3 Điều 3 Văn Bản này là điều kiện bắt buộc để Viettel có thể cung cấp Sản phẩm, hàng hóa, dịch vụ theo Hợp đồng, đảm bảo chất lượng và trải nghiệm sử dụng dịch vụ của Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em. </p>
                <p>Đối với các mục đích theo khoản 4, 5, 6 Điều 3 Văn Bản này, chúng tôi chỉ thực hiện xử lý dữ liệu khi có sự đồng ý bằng tích chọn của Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em. Trường hợp Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em đã đồng ý cho chúng tôi Xử lý dữ liệu mà thay đổi ý định và/hoặc muốn từ chối nhận thông tin tiếp thị, giới thiệu sản phẩm, quảng cáo và khuyến mại, Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em có thể cho chúng tôi biết bất kỳ lúc nào bằng việc gửi yêu cầu cho chúng tôi theo các phương thức theo quy định tại khoản 13 Điều 10 Văn Bản này. </p>
                <p>Ngoại trừ các mục đích xử lý dữ liệu nêu trên, nếu cần xử lý dữ liệu cá nhân của Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em cho bất kỳ mục đích nào khác, chúng tôi sẽ thông báo cho Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em và chỉ tiến hành xử lý dữ liệu cá nhân phù hợp với sự đồng ý của Cha, mẹ, người giám hộ hợp pháp của Khách hàng trẻ em.</p> */}
                <i ref={ref} id='accept-policy'>Tôi xác nhận đã đọc và hiểu đầy đủ nội dung của Văn Bản này và theo đây đồng ý với việc xử lý dữ liệu cá nhân của Khách hàng trẻ em (bao gồm cả Dữ liệu cá nhân nhạy cảm của Khách hàng trẻ em) theo các điều khoản và điều kiện được quy định trong Văn Bản. Tôi xác nhận rằng các nội dung được đánh dấu tại Phụ lục 02 này là đúng, chính xác và phù hợp với ý định của tôi.</i>
            </DialogContent>
            <DialogActions>
                <Button disabled={!scrollEnd} variant='outlined' onClick={handleReject}>{t('actions.reject')}</Button>
                <Button disabled={!isValid} onClick={handleAction}>{t('actions.accept')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogAcceptPolicy